import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

interface PatientSearchParams {
  visitId?: string;
  mrn?: string;
  patientId?: string;
  patientFirstName?: string;
  patientLastName?: string;
  dob?: string;
}

interface PatientSearchResponse {
  results: PatientSearchResult[];
}

interface PatientSearchError {
  detail: string;
}

export interface PatientSearchResult {
  administrativeGender: string;
  age: number;
  dob: string;
  externalMrn?: string;
  firstName: string;
  genderIdentity: string;
  homeAddressState?: string;
  lastName: string;
  mrn: string;
  partnerUids: string[];
  preferredPartnerUid?: string | null;
  patientId: string;
  userId?: string;
  visitRfe?: string;
}

export const usePatientSearch = ({
  visitId,
  patientId,
  patientFirstName,
  patientLastName,
  dob,
}: PatientSearchParams) => {
  const params = {
    visitId: visitId,
    mrn: patientId,
    firstName: patientFirstName,
    lastName: patientLastName,
    dob,
  };

  const enabled =
    !!visitId ||
    !!patientId ||
    !!patientFirstName ||
    !!patientLastName ||
    !!dob;

  return useApi<
    PatientSearchResponse,
    PatientSearchResponse,
    PatientSearchError
  >({
    queryOptions: {
      enabled,
      queryFn: async () => {
        const response = await axiosInstance.get<PatientSearchResponse>(
          "/new-api/patient/search",
          { params },
        );

        return response.data;
      },
      queryKey: QueryKeys.Provider.Search.PATIENT(params),
    },
  });
};
